import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import Stats from "three/examples/jsm/libs/stats.module";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";
import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass";
import { OutputPass } from "three/examples/jsm/postprocessing/OutputPass";

if (typeof window !== "undefined") {
  window.THREE = THREE;
}
const THREEJS = {
  ...THREE,
  GLTFLoader,
  OBJLoader,
  FBXLoader,
  OrbitControls,
  EffectComposer,
  RenderPass,
  ShaderPass,
  OutputPass,
  Stats,
};

export default THREEJS;
